import { Download, Edit } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Chip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const ListSubmissionUserColumnShape = ({ 
    handleDownloadCertificate, 
    downloading, 
    downloadingId }) => [
    {
        Header: 'Title',
        accessor: 'title',
        Cell: ({ value }) => (
            <Typography> {value ? value : 'Untitled'} </Typography>
        ),
    },
    {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ value }) => <Typography>{value}</Typography>,
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => (
            <Chip
                label={value.label}
                color={value.style}
            />
        ),
    },
    {
        Header: 'Certificate',
        accessor: 'certificate',
        Cell: ({ row }) => {
            const downloadingLabel = downloadingId === row.original.id ? 'Downloading ...' : 'Download Certificate';
            const isRowLoading = downloadingId === row.original.id;
            const isShowIcon = !downloading.value || !isRowLoading;
            return (
                <Box>
                    {row.original.certificate 
                    ? (
                        <LoadingButton
                            variant="contained"
                            color="info"
                            size="small"
                            loading={isRowLoading}
                            disabled={downloading.value}
                            sx={{ whiteSpace: 'nowrap', borderRadius: 8, py: 0.5, pr: isRowLoading ? 4 : 2 }}
                            startIcon={isShowIcon ? <Download /> : null}
                            onClick={() => handleDownloadCertificate(row.original)}
                            loadingPosition="end"
                        >
                            { downloading ? downloadingLabel : 'Download Certificate' }
                        </LoadingButton>
                    ) 
                    : (
                        <Typography variant="body2" style={{ color: 'red', textDecoration: 'italic' }}>
                            Not Available
                        </Typography>
                    )}
                </Box>
            )
        },
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => (
            <Link to={`/dashboard/abstract-edit/${row.original.id}`} clickable>
                <Chip
                    label={`Edit`}
                    color="primary"
                    icon={ <Edit fontSize="small" /> }
                    sx={{ px: 1 }}
                    clickable
                />
            </Link>
        ),
    }
];


export default ListSubmissionUserColumnShape;
